module.exports = new __parcel__URL__("stars.cb6df0b3.webp").toString();